module.exports = __webpack_public_path__ + "img/contact.14b31da8.jpg";